export const ErrorConstants = {
    abortError: 'AbortError',
    canceledError: 'CanceledError',
    noEditorAccessError: 'NoEditorAccessError',
    imageSizeError: 'Image size is more than 10 MB. Please upload smaller image.',
    requestBodyError: 'Request body too large. The max request body size is 30000000 bytes.',
    imageCorruptError: 'Image file corrupt.',
}
